<template>
	<v-container fluid class="mt-4">
	  <v-row>
	  	<v-col cols="12">
				<v-card class="shadowCard">

					<v-card-title primary-title>
			      <label class="text-subtitle-1 black--text">Validación de Pagos</label>
			      <v-spacer></v-spacer>


            <!-- Boton para descargar el excel -->
            <v-btn
              class="mr-2"
              small
              dark
              color="orange"
              @click="abrirValidacion()"

              outlined
            >
              <v-icon>mdi-cash-check</v-icon>
            </v-btn>

            <!-- Botón par aexportar -->
            <v-btn
              class="mr-2"
              small dark color="green"
              @click="exportar()"
              tile
            >
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              class="mr-2"
              small dark color="primary"
              @click="getReporteTotalPagos()"
              tile
            >
              <v-icon left small>mdi-file</v-icon>
              R. Total
            </v-btn>

            <v-btn
              class="mr-2"
              small dark color="teal accent-3"
              @click="reporteFechas.status = true"
              tile
            >
              <v-icon left small>mdi-file</v-icon>
              R. Rango Fechas
            </v-btn>

			      <v-btn color="primary" tile small @click="consultar( null, null, 1 )">
			        <v-icon small left>mdi-refresh</v-icon>
			        Actualizar
			      </v-btn>


					</v-card-title>
			    <v-card-text>

            <v-row>

              <v-col cols="12" md="4" lg="2" class="pb-0">
                <label>Selecciona un ciclo</label>
                <v-autocomplete
                  label="Ciclo"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  v-model="ciclo"
                  :items="ciclos"
                  item-text="ciclo"
                  item-value="id_ciclo"
                  clearable
                ></v-autocomplete>
              </v-col>


              <v-col cols="12" sm="4" lg="2" xl="2">
                <label>Fecha de inicio</label>
                <v-text-field
                  label="Fecha de incio"
                  filled
                  dense
                  clearable
                  v-model="fecha_inicio"
                  type="date"
                  single-line
                  @keyup.enter="consultar( null, null, 1 )"
                ></v-text-field>
              </v-col>


              <v-col cols="12" sm="4" lg="2" xl="2">
                <label>Fecha final</label>
                <v-text-field
                  label="Fecha de incio"
                  filled
                  dense
                  clearable
                  v-model="fecha_final"
                  type="date"
                  single-line
                  @keyup.enter="consultar( null, null, 1 )"
                ></v-text-field>
              </v-col>

              <!-- Forma de pago -->
              <v-col cols="12" md="4" lg="2" xl="2">
                <label>Tipo de pago</label>
                <v-select
                  :items="tipos_pago"
                  v-model="formaPago"
                  label="Forma de pago"
                  filled
                  dense
                  item-text="tipo"
                  single-line
                  item-value="id"
                ></v-select>
              </v-col>

              <!-- Forma de pago -->
              <v-col cols="12" md="4" lg="2" xl="2">
                <label>Encontrados</label>
                <v-select
                  :items="encontrados"
                  v-model="encontrado"
                  label="Encontrado"
                  filled
                  dense
                  item-text="tipo"
                  single-line
                  item-value="id"
                ></v-select>
              </v-col>

              <!-- ESTATUS -->
              <v-col cols="12" md="4" lg="2" xl="2">
                <label>Estatus</label>
                <v-select
                  :items="validados"
                  v-model="estatus"
                  label="Estatus"
                  filled
                  dense
                  item-text="tipo"
                  single-line
                  item-value="id"
                ></v-select>
              </v-col>

              <v-col cols="12" md="5" lg="3">
                <v-radio-group
                  v-model="opEscuela"
                  row
                >
                  <v-radio
                    label="INBI"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="FAST"
                    :value="2"
                  ></v-radio>
                  <v-radio
                    label="TODOS"
                    :value="3"
                  ></v-radio>
                </v-radio-group>
              </v-col>

            </v-row>

			    	<v-row justify="space-between">

              <v-col cols="12" md="3" lg="3">

                <span class="black--text text-h8">
                  <b>Aceptados:</b>
                   {{ filterRevisadosMonto }} | {{ filterRvisados }} | {{ (( filterRvisados / filterMovimientos ) * 100).toFixed( 2 ) }} % |
                </span>
                <br/>

                <span class="black--text text-h8">
                  <b>Rechazados:</b>
                   {{ filterRechazadosMonto }} | {{ filterRechazados }} | {{ (( filterRechazados / filterMovimientos ) * 100).toFixed( 2 ) }} % |
                </span>
                <br/>

                <span class="black--text text-h8">
                  <b>Pendientes:</b>
                   {{ filterFaltantesMonto }} | {{ filterFaltantes }} | {{ (( filterFaltantes / filterMovimientos ) * 100).toFixed( 2 ) }} % |
                </span>
                <br/>
                
                <span class="black--text text-h8">
                  <b>Todos:</b>
                   {{ filterMovimientosMonto }} | {{ filterMovimientos }} |  % |
                </span>
                <br/>

              </v-col>

              <!-- Estatus de revisados y sin revisar -->
              <v-col cols="12" md="5" lg="5">
                <v-radio-group
                  v-model="opEstatus"
                  row
                >
                  <v-radio
                    label="Aceptados"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="Rechazados"
                    :value="2"
                  ></v-radio>
                  <v-radio
                    label="Pendientes"
                    :value="3"
                  ></v-radio>
                  <v-radio
                    label="Todos"
                    :value="4"
                  ></v-radio>
                </v-radio-group>
              </v-col>

			    		<v-col cols="12" md="6" lg="4">
					      <v-text-field
					        filled
					        dense
					        append-icon="mdi-magnify"
					        label="Búscar"
					        v-model="searchMovimientos"
					      ></v-text-field>
			    		</v-col>
			    	</v-row>

			      <v-data-table
			        :headers="headersDos"
			        :items="filterCorte"
			        dense
			        :search="searchMovimientos"
			        mobile-breakpoint="200"
			        item-class="cambio"
			      >

			        <template v-slot:item.aceptado="{ item }">
                <v-chip small color="blue"  dark v-if="item.aceptado == 1">Aceptado</v-chip>
                <v-chip small color="red"   dark v-else-if="item.aceptado == 2">Rechazado</v-chip>

                <span v-if="item.aceptado == 2"><br/>{{ item.motivo }}</span>

                <v-btn tile x-small color="green" dark v-if="!item.aceptado == 1 && ![18, 19, 17].includes(getdatosUsuarioERPERP.idpuesto)" class="mt-2" @click="aceptarComprobante( item )"><v-icon small>mdi-check</v-icon></v-btn>
                <v-btn tile x-small color="red"   dark v-if="!item.aceptado == 1 && ![18, 19, 17].includes(getdatosUsuarioERPERP.idpuesto)" class="mt-2" @click="confirmarRechazo( item )"><v-icon small>mdi-close</v-icon></v-btn>

              </template>


              <template v-slot:item.estatus="{ item }">
                <v-chip @click="datosRevision = item, dialogRevision = true" small v-if="mostrarValidadoPorCorte(item)" color="teal" dark>Validado por corte</v-chip>
                <v-chip @click="datosRevision = item, dialogRevision = true" small v-else-if="item.estatus == 2 && item.match_hermanos && !item.error_monto" color="deep-purple" dark>Match Hermanos</v-chip>
                <v-chip @click="datosRevision = item, dialogRevision = true" small v-else-if="item.estatus == 2 && item.error_monto"  color="red"   dark>Match Error monto</v-chip>
                <v-chip @click="datosRevision = item, dialogRevision = true" small v-else-if="item.estatus == 2 && !item.error_monto" color="green" dark>Con Match 100%</v-chip>
                <span         v-if="!item.estatus && !mostrarValidadoPorCorte(item) && !mostrarFoliosComprobanteReutilizado(item) && !mostrarComprobanteMismoAlumno(item)">Sin Match</span>
                <div v-if="item.match_hermanos" class="caption mt-1">
                  Hermanos con: {{ item.hermanos_matriculas }}
                </div>
                <div class="mt-1">
                  <v-chip
                    v-if="mostrarFoliosComprobanteReutilizado(item)"
                    @click="datosRevision = item, dialogRevision = true"
                    small
                    color="orange"
                    dark
                    class="mr-1"
                  >Comprobante reutilizado</v-chip>
                  <v-chip
                    v-else-if="mostrarComprobanteMismoAlumno(item)"
                    @click="datosRevision = item, dialogRevision = true"
                    small
                    color="amber darken-2"
                    dark
                  >Mismo alumno</v-chip>
                </div>
              </template>

              <template v-slot:item.id_ingreso="{ item }">
                <v-icon small left color="green" v-if="item.encontrado">mdi-check</v-icon> {{ item.id_ingreso }}

              </template>

			        <template v-slot:item.url_foto="{ item }">
			          <p @click="comprobarImagen(item)" type="button" v-if="item.forma_pago != 'EFECTIVO' ">
			            <img :src="url_servidor + '/comprobante-pago/' + item.url_foto" alt="Comprobante" width="45"/>
			          </p>
			        </template>

              <template v-slot:item.texto_completo="{ item }">
                <v-chip
                  v-if="item.id_forma_pago != 1"
                  :color="item.texto_completo ? 'green' : 'red'"
                  dark
                  small
                  label
                >
                  {{ item.texto_completo ? 'Leído' : 'Error' }}
                </v-chip>
              </template>

			        <template v-slot:item.con_adeudo="{ item }">
			          <v-chip
			            small
			            color="primary"
			            @click="abrirDialog(item.con_adeudoA)"
			          >
			            {{ item.con_adeudo }}
			          </v-chip>
			        </template>

			      </v-data-table>
			    </v-card-text>



          <!-- Dialogo para reporte de pagos -->
          <v-dialog v-model="dialogPagos" max-width="1200px">
            <v-card>
              <v-card-title>
                <span class="headline">Reporte de Pagos</span>

                <v-spacer></v-spacer>
                <v-btn
                  class="mr-2"
                  small dark color="green"
                  @click="exportExcel( reporte, 'reporte-pagos')"
                  tile
                >
                  <v-icon small>mdi-microsoft-excel</v-icon>
                </v-btn>
                <v-btn fab small text @click="dialogPagos=false"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>



              <v-card-text >

                <v-col cols="12" md="3" lg="3">
                <span class="black--text text-h8">
                  <b>Movimientos:</b>
                   | {{ movimientosReporte }} |
                </span>
                <br/>
                <span class="black--text text-h8">
                  <b>Revisados:</b>
                   | {{ revisadosReporte }} |
                </span>
                <br/>
                <span class="black--text text-h8">
                  <b>Faltantes:</b>
                  | {{ faltantesReporte }} |
                </span>
                <br/>
                <span class="black--text text-h8">
                  <b>% Revisados:</b>
                   | {{ porcentajeReporte }} % |
                </span>
              </v-col>

                <v-data-table
                  :headers="headersReporte"
                  :items="reporte"
                  class="elevation-0"
                  dense
                  multi-sort
                >
                  <template v-slot:item.porcentaje="{ item }">
                    {{ item.porcentaje }}%
                  </template>

                  <template v-slot:item.Bloqueado="{ item }">
                    <v-chip
                      small
                      :color="item.Bloqueado == 1 ? 'red' : 'green' "
                      dark
                    >
                      {{ item.Bloqueado == 1 ? 'Bloqueado' : 'Liberado' }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="black"
                  dark
                  small
                  tile
                  @click="dialogPagos=false"
                >
                  <v-icon left small>mdi-close</v-icon>
                  Cancelar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

			    <!-- Dialog para ver la imagen -->
          <!-- Visor comprobante (como antes: clic zoom 100%/200%) -->
          <v-dialog
            v-model="dialgImagen"
            max-width="800px"
          >
            <v-card>
              <v-card-text style="width: 100%; height: 800px; overflow: auto;" ref="contenedorZoom">
                <img
                  v-if="imagen"
                  :src="url_servidor + '/comprobante-pago/' + imagen"
                  ref="imagenZoom"
                  :style="{
                    width: zoomActivo ? '200%' : '100%',
                    height: 'auto',
                    cursor: zoomActivo ? 'zoom-out' : 'zoom-in'
                  }"
                  @click="toggleZoom"
                />
              </v-card-text>

              <v-card-text>
                {{ texto_completo }}
              </v-card-text>

              <v-btn
                absolute
                right
                top
                color="grey"
                dark
                fab
                class="elevation-6 mt-8"
                @click="cerrarDialogo"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card>
          </v-dialog>

          <!-- Zoom tipo tickets solo para evidencias de corte -->
          <ImagenVisor
            @close="cerrarVisorCorte"
            :isOpen="dialgImagenCorte"
            :imagen="imagenCorte"
            :imagenes="imagenesVisorCorte"
            :indiceInicial="indiceImagenVisorCorte"
            :baseUrl="baseUrlComprobante"
          />

          <v-dialog
            v-model="dialogConfirma"
            max-width="550px"
          >
            <v-card class="elevation-0">
              <v-card-title primary-title>
                Selecciona el por qué se está rechazando el ingreso
              </v-card-title>
              <v-card-text>
                <v-autocomplete
                  v-if="datosPago"
                  :items="conceptosError"
                  v-model="datosPago.iderrores_pagos"
                  label="Motivo de rechazo"
                  dense
                  filled
                  item-value="iderrores_pagos"
                  item-text="motivo"
                  class="ma-2"
                  hide-details
                ></v-autocomplete>
              </v-card-text>
              <!-- Guardar la información  -->
              <v-btn
                absolute
                right
                top
                small
                icon
                class="elevation-6"
                @click="dialogConfirma = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="green"
                  dark
                  tile
                  small
                  @click="rechazarComprobante( datosPago )"
                >
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogRevision"
            max-width="600px"
          >
            <v-card>
              <v-card-title class="headline">
                Detalles del registro
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogRevision = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text v-if="datosRevision">
                <v-row>
                  <v-col cols="12" md="6">
                    <h3 class="subtitle-1 font-weight-bold mb-2">Datos del Excel</h3>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>ID EXCEL</v-list-item-subtitle>
                        <v-list-item-title class="mt-2">{{ datosRevision.dbData.idexcel_ingresos_detalles }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Fecha y Hora</v-list-item-subtitle>
                        <v-list-item-title class="mt-2">{{ getFechaPagoComprobante(datosRevision) }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Banco</v-list-item-subtitle>
                        <v-list-item-title class="mt-2">
                          <v-chip
                            x-small
                            :color="getBancoColor(datosRevision.dbData.bancoArchivo)"
                            text-color="white"
                          >
                            {{ getBancoLabel(datosRevision.dbData.bancoArchivo) }}
                          </v-chip>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Tipo</v-list-item-subtitle>
                        <v-list-item-title class="mt-2">
                          <v-chip
                            x-small
                            :color="getBancoColor(datosRevision.dbData.bancoArchivo)"
                            text-color="white"
                          >
                            {{ datosRevision.dbData.tipo_transaccion }}
                          </v-chip>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Coincidencia</v-list-item-subtitle>
                        <v-list-item-title class="mt-2">
                          <v-chip x-small color="indigo" text-color="white">
                            {{ infoCoincidencia(datosRevision).coincidencia }}
                          </v-chip>
                        </v-list-item-title>
                        <v-list-item-title class="text-wrap caption mt-2" v-if="infoCoincidencia(datosRevision).valor_ingreso">
                          En el comprobante: {{ infoCoincidencia(datosRevision).valor_ingreso }}
                        </v-list-item-title>
                        <v-list-item-title class="text-wrap caption" v-if="infoCoincidencia(datosRevision).valor_banco">
                          En el banco: {{ infoCoincidencia(datosRevision).valor_banco }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Concepto/Referencia</v-list-item-subtitle>
                        <v-list-item-title class="text-wrap mt-2" v-if="datosRevision.dbData.tipo_transaccion == 'TPV' && datosRevision.dbData.bancoEncontrado == 'HSBC'">
                          {{ datosRevision.dbData.codigo_autorizacion }}
                        </v-list-item-title>

                        <v-list-item-title class="text-wrap mt-2" v-if="datosRevision.dbData.tipo_transaccion == 'EDO CUENTA' && datosRevision.dbData.bancoEncontrado == 'SEVEN'">
                          {{ datosRevision.dbData.concepto }}
                        </v-list-item-title>

                        <v-list-item-title class="text-wrap mt-2" v-if="datosRevision.dbData.tipo_transaccion == 'EDO CUENTA' && datosRevision.dbData.bancoEncontrado == 'HSBC'">
                          {{ datosRevision.dbData.ref_hsbc_2 }}
                          {{ datosRevision.dbData.ref_hsbc_3 }}
                        </v-list-item-title>

                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>Monto</v-list-item-subtitle>
                        <v-list-item-title>{{ montoBancoMostrar(datosRevision) }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <!-- DATOS PARA INDICAR QUE ESTA MAL EL MONTO -->
                    <v-list-item v-if="datosRevision.match_hermanos">
                      <v-list-item-content>
                        <v-list-item-subtitle class="font-weight-bold deep-purple--text">Pago compartido entre hermanos</v-list-item-subtitle>
                        <v-list-item-title>
                          Hermanos con: {{ datosRevision.hermanos_matriculas }}
                        </v-list-item-title>
                        <v-list-item-title class="mt-1">
                          Monto banco: {{ format( datosRevision.dbData.banco ) }}
                          <v-icon small>mdi-plus</v-icon>
                          Suma hermanos: {{ format( datosRevision.monto_grupo_hermanos ) }}
                        </v-list-item-title>
                        <v-list-item-title class="caption mt-1">
                          Este ingreso: {{ format( datosRevision.monto_pagado ) }} (el comprobante cubre el total del grupo)
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="datosRevision.match_hermanos"></v-divider>

                    <v-list-item v-if="datosRevision.error_monto && !datosRevision.match_hermanos">
                      <v-list-item-content>
                        <v-list-item-subtitle class="font-weight-bold error--text">¡Diferencia en montos!</v-list-item-subtitle>
                        <v-list-item-title>
                          Excel: {{ format( datosRevision.dbData.banco ) }}
                          <v-icon small color="error">mdi-arrow-left-right</v-icon>
                          BD: {{ format( datosRevision.monto_pagado ) }}
                        </v-list-item-title>
                        <v-list-item-title class="error--text">
                          Diferencia: {{ format( datosRevision.dbData.banco - datosRevision.monto_pagado ) }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="datosRevision.error_monto && !datosRevision.match_hermanos"></v-divider>

                    <!-- <v-list-item v-if="datosRevision.dbData && datosRevision.dbData.matchInfo">
                      <v-list-item-content>
                        <v-list-item-subtitle class="font-weight-bold">Información de coincidencia</v-list-item-subtitle>
                        <v-list-item-title class="text-wrap">
                          Referencia extraída: {{ datosRevision.dbData.matchInfo.referencia_extraida }}
                        </v-list-item-title>
                        <v-list-item-title>
                          Campo de coincidencia:
                          <v-chip x-small color="primary" text-color="white">
                            {{ datosRevision.dbData.matchInfo.tipo_coincidencia === 'clave_rastreo' ? 'Clave de Rastreo' :
                               datosRevision.dbData.matchInfo.tipo_coincidencia === 'folio_operacion' ? 'Folio de Operación' :
                               'Texto Completo' }}
                          </v-chip>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider> -->

                    <!-- <v-list-item v-if="datosRevision.detailedInfo">
                      <v-list-item-content>
                        <v-list-item-subtitle class="font-weight-bold mb-2">Información Extraída</v-list-item-subtitle>

                        <div v-if="datosRevision.detailedInfo.numericalGroups && datosRevision.detailedInfo.numericalGroups.length > 0" class="mb-2">
                          <span class="font-weight-medium">Referencias Numéricas:</span>
                          <div v-for="(num, index) in datosRevision.detailedInfo.numericalGroups" :key="'num-'+index" class="ml-2">
                            <span class="text-wrap">{{ num }}</span>
                          </div>
                        </div>

                        <div v-if="datosRevision.detailedInfo.textGroups && datosRevision.detailedInfo.textGroups.length > 0" class="mb-2">
                          <span class="font-weight-medium">Texto Extraído:</span>
                          <div v-for="(text, index) in datosRevision.detailedInfo.textGroups" :key="'text-'+index" class="ml-2">
                            <span class="text-wrap">{{ text }}</span>
                          </div>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider> -->
                  </v-col>
                  <v-col cols="12" md="6">
                    <h3 class="subtitle-1 font-weight-bold mb-2">Datos de la Base</h3>
                    <template v-if="datosRevision">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>ID Ingreso</v-list-item-subtitle>
                          <v-list-item-title>{{ datosRevision.id_ingreso }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Alumno</v-list-item-subtitle>
                          <v-list-item-title>{{ datosRevision.alumno }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Monto Pagado</v-list-item-subtitle>
                          <v-list-item-title>{{ format( datosRevision.monto_pagado ) }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Fecha de Pago</v-list-item-subtitle>
                          <v-list-item-title>{{ getFechaPagoComprobante(datosRevision) }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Comprobante</v-list-item-subtitle>
                          <v-list-item-title v-if="datosRevision.url_foto">
                            <v-img
                              :src="datosRevision && datosRevision.url_foto ? url_servidor + '/comprobante-pago/' + datosRevision.url_foto : ''"
                              max-height="150"
                              max-width="300"
                              contain
                              class="cursor-pointer"
                              @click="comprobarImagen(datosRevision)"
                            ></v-img>
                          </v-list-item-title>
                          <v-list-item-title v-else>
                            <v-chip small color="warning" text-color="white">Sin comprobante</v-chip>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Clave Rastreo</v-list-item-subtitle>
                          <v-list-item-title>{{ datosRevision.aut_clave_rastreo }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>Folio Operación</v-list-item-subtitle>
                          <v-list-item-title>{{ datosRevision.folio_operacion }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item v-if="datosRevision && datosRevision.texto_completo">
                        <v-list-item-content>
                          <v-list-item-subtitle>Texto Completo</v-list-item-subtitle>
                          <v-list-item-title
                            class="text-wrap texto-completo-fechas"
                            v-html="textoCompletoConFechaResaltada(datosRevision.texto_completo)"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <v-alert v-else type="error" dense>No se encontró coincidencia en la base de datos</v-alert>
                  </v-col>
                </v-row>
              </v-card-text>
              <!-- Panel de búsqueda en base de datos -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialogRevision = false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <PagosPorFecha :reporteFechas="reporteFechas" :ciclos="ciclos"></PagosPorFecha>

			    <!-- Dialog de carga -->
			    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
			    <carga v-if="cargar && !dialogValidacion" />

			  </v-card>
	  	</v-col>
	  </v-row>

    <v-dialog
      v-model="dialogValidacion"
      max-width="800px"
    >
      <v-card>
        <v-card-title class="headline">
          Detalles movimientos
          <v-spacer></v-spacer>
          <v-btn class="mr-2" color="primary" tile small @click="consultarValidacion(true)">
            <v-icon small left>mdi-refresh</v-icon>
            Actualizar
          </v-btn>
          <v-btn
            class="mr-2"
            small
            dark
            color="green"
            tile
            @click="exportarMatch()"
          >
            <v-icon small left>mdi-microsoft-excel</v-icon>
            Excel
          </v-btn>
          <v-btn icon @click="dialogValidacion = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row >
            <v-col cols="12">
              <div>
                <v-icon left small color="blue">mdi-clipboard-list-outline</v-icon>Total de registros:<b> {{ totalRegistros }}</b><br/>
                <v-icon left small color="green">mdi-clipboard-check</v-icon>      Validados:         <b> {{ registrosValidados }}</b><br/>
                <v-icon left small color="yellow">mdi-alert</v-icon>               Avance:            <b> {{ avanceValidados }}</b><br/>
                <v-icon left small color="orange">mdi-check</v-icon>               Con match:         <b> {{ registrosConMatch }}</b><br/>
                <v-icon left small color="red">mdi-close</v-icon>                  Sin match:         <b> {{ registrosSinMatch }}</b><br/>
                <v-icon left small color="pink">mdi-alert-circle</v-icon>          Error monto:       <b> {{ registrosErrorMonto }}</b><br/>
              </div>
            </v-col>
          </v-row>

          <v-row >
            <v-col cols="12">
              <span class="caption grey--text">Primero elige la fecha de inicio y luego la fecha final.</span>
            </v-col>
            <v-col cols="12" sm="6">
              <label>Fecha de inicio</label>
              <v-menu
                v-model="menuFechaInicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fecha_inicio_modal"
                    label="Fecha de inicio"
                    placeholder="dd/mm/aaaa"
                    prepend-inner-icon="mdi-calendar"
                    filled
                    dense
                    clearable
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="limpiarFechaModal('inicio')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :value="fecha_inicio_modal"
                  locale="es"
                  no-title
                  @input="seleccionarFechaModal('inicio', $event)"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
              <label>Fecha final</label>
              <v-menu
                v-model="menuFechaFinal"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="fecha_final_modal"
                    label="Fecha final"
                    placeholder="dd/mm/aaaa"
                    prepend-inner-icon="mdi-calendar"
                    filled
                    dense
                    clearable
                    hide-details
                    readonly
                    :disabled="!fecha_inicio_modal"
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="limpiarFechaModal('final')"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :value="fecha_final_modal"
                  locale="es"
                  no-title
                  :min="minFechaFinal"
                  :max="maxFechaFinal"
                  @input="seleccionarFechaModal('final', $event)"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="12">
              <label>Elige una opción</label>
              <v-radio-group
                v-model="opFiltroValidaPdf"
                row
              >
                <v-radio
                  label="Todos"
                  :value="0"
                ></v-radio>
                <v-radio
                  label="Con Match"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="Sin Match"
                  :value="2"
                ></v-radio>
                <v-radio
                  label="Error monto"
                  :value="5"
                ></v-radio>
                <v-radio
                  label="Sin validar"
                  :value="3"
                ></v-radio>
                <v-radio
                  label="Match Sin validar"
                  :value="4"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" md="12">
              <label>Validación</label>
              <v-radio-group
                v-model="opEstatusModal"
                row
              >
                <v-radio
                  label="Aceptados"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="Rechazados"
                  :value="2"
                ></v-radio>
                <v-radio
                  label="Pendientes"
                  :value="3"
                ></v-radio>
                <v-radio
                  label="Todos"
                  :value="4"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                v-model="formaPagoModal"
                :items="[
                  { id: 0, tipo: 'Todos' },
                  { id: 1, tipo: 'Efectivo' },
                  { id: 2, tipo: 'Digital' },
                ]"
                label="Tipo de pago"
                item-text="tipo"
                item-value="id"
                filled
                dense
                hide-details
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                v-model="opEscuelaModal"
                :items="[
                  { id: 1, tipo: 'INBI' },
                  { id: 2, tipo: 'FAST' },
                  { id: 3, tipo: 'TODOS' },
                ]"
                label="Escuela"
                item-text="tipo"
                item-value="id"
                filled
                dense
                hide-details
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                label="Buscar"
                v-model="search"
                filled
                dense
                hide-details
              ></v-text-field>
            </v-col>

          </v-row>
        </v-card-text>

        <div v-if="cargarMatch">
          <v-progress-linear
            indeterminate
            color="cyan"
          ></v-progress-linear>
        </div>
        <v-card-text v-if="filterValidadosFiltrados.length" >
          <div class="caption grey--text mb-2">
            Mostrando {{ rangoPaginaModal }} de {{ filterValidadosFiltrados.length }}
          </div>
          <v-row v-for="datosRevision in filterValidadosPagina" :key="datosRevision.id_ingreso">
            <v-col cols="12">
              <v-app-bar
                dense
                flat
                :color="getEscuelaColor(datosRevision)"
                dark
                class="mb-2"
              >
                <v-toolbar-title class="subtitle-2 font-weight-bold">
                  {{ getEscuelaLabel(datosRevision) }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <span class="caption">{{ datosRevision.plantel }}</span>
              </v-app-bar>
            </v-col>

            <v-col cols="12" md="6">
              <h3 class="subtitle-1 font-weight-bold mb-2">Pagos ingresados al sistema</h3>
              <v-alert
                v-if="datosRevision.match_hermanos"
                type="info"
                dense
                outlined
                class="mb-3"
              >
                <strong>Hermanos con:</strong> {{ datosRevision.hermanos_matriculas }}<br/>
                Monto banco: {{ format( datosRevision.dbData ? datosRevision.dbData.banco : 0 ) }}
                | Suma hermanos: {{ format( datosRevision.monto_grupo_hermanos ) }}<br/>
                <span class="caption">Este ingreso: {{ format( datosRevision.monto_pagado ) }} — el comprobante cubre el total del grupo</span>
              </v-alert>
              <template v-if="datosRevision">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>ID Ingreso</v-list-item-subtitle>
                    <v-list-item-title>{{ datosRevision.id_ingreso }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Alumno</v-list-item-subtitle>
                    <v-list-item-title>{{ datosRevision.alumno }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Monto Pagado</v-list-item-subtitle>
                    <v-list-item-title >
                      <div class="fondo_color">{{ format( datosRevision.monto_pagado ) }}</div>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Fecha de Pago</v-list-item-subtitle>
                    <v-list-item-title>{{ getFechaPagoComprobante(datosRevision) }}</v-list-item-title>
                    <v-list-item-subtitle v-if="datosRevision.fecha_pago_sistema && datosRevision.fecha_pago_sistema != datosRevision.fecha_pago">
                      Registro original: {{ datosRevision.fecha_pago_sistema }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Comprobante</v-list-item-subtitle>
                    <v-list-item-title v-if="datosRevision.url_foto">
                      <v-img
                        :src="datosRevision && datosRevision.url_foto ? url_servidor + '/comprobante-pago/' + datosRevision.url_foto : ''"
                        max-height="150"
                        max-width="300"
                        contain
                        class="cursor-pointer"
                        @click="comprobarImagen(datosRevision)"
                      ></v-img>
                    </v-list-item-title>
                    <v-list-item-title v-else>
                      <v-chip small color="warning" text-color="white">Sin comprobante</v-chip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Clave Rastreo</v-list-item-subtitle>
                    <v-list-item-title>{{ datosRevision.aut_clave_rastreo }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Folio Operación</v-list-item-subtitle>
                    <v-list-item-title>{{ datosRevision.folio_operacion }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-if="datosRevision && datosRevision.texto_completo">
                  <v-list-item-content>
                    <v-list-item-subtitle>Texto Completo</v-list-item-subtitle>
                    <v-list-item-title
                      class="text-wrap texto-completo-fechas"
                      v-html="textoCompletoConFechaResaltada(datosRevision.texto_completo)"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-alert v-else type="error" dense>No se encontró coincidencia en la base de datos</v-alert>
            </v-col>

            <v-col cols="12" md="6">
              <template v-if="mostrarValidadoPorCorte(datosRevision)">
                <h3 class="subtitle-1 font-weight-bold mb-2">Validación por corte</h3>
                <v-alert type="info" dense outlined class="mb-3">
                  Validado de forma automática por corte
                </v-alert>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Folio de corte</v-list-item-subtitle>
                    <v-list-item-title>{{ (datosRevision.corte_info && datosRevision.corte_info.folio_corte) || datosRevision.folio_operacion }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Monto recibido en corte</v-list-item-subtitle>
                    <v-list-item-title>
                      <template v-if="datosRevision.corte_info && datosRevision.corte_info.monto_recibido != null">
                        {{ format(datosRevision.corte_info.monto_recibido) }}
                      </template>
                      <span v-else class="grey--text">Sin monto de corte registrado</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-if="datosRevision.corte_info && datosRevision.corte_info.fecha_hora_corte">
                  <v-list-item-content>
                    <v-list-item-subtitle>Fecha/hora del corte</v-list-item-subtitle>
                    <v-list-item-title>{{ formatFechaCorta(datosRevision.corte_info.fecha_hora_corte) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="evidenciasCorte(datosRevision).length"></v-divider>
                <v-list-item v-if="evidenciasCorte(datosRevision).length">
                  <v-list-item-content>
                    <v-list-item-subtitle>Evidencias del corte</v-list-item-subtitle>
                    <div class="mt-2 d-flex flex-wrap">
                      <a
                        v-for="(ev, idx) in evidenciasCorte(datosRevision)"
                        :key="'corte-ev-' + idx"
                        href="javascript:void(0)"
                        class="mr-2 mb-2"
                        @click.prevent="verEvidenciaCorte(ev, idx)"
                      >
                        <img
                          :src="urlComprobantePago(ev)"
                          alt="Evidencia corte"
                          width="90"
                          style="object-fit: cover; border-radius: 4px; border: 1px solid #ddd; cursor: pointer;"
                        />
                      </a>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-else-if="mostrarFoliosComprobanteReutilizado(datosRevision)">
                <h3 class="subtitle-1 font-weight-bold mb-2">Folios con los que hizo match</h3>
                <v-alert type="warning" dense outlined class="mb-3">
                  Este comprobante ya se utilizó en otros ingresos (no hermanos).
                </v-alert>
                <v-simple-table dense class="mb-2">
                  <thead>
                    <tr>
                      <th>Folio</th>
                      <th>Alumno</th>
                      <th>Fecha</th>
                      <th>Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="p in (datosRevision.folios_comprobante_previos || [])" :key="'prev-' + p.id_ingreso">
                      <td>{{ p.id_ingreso }}</td>
                      <td>{{ p.alumno }}<span v-if="p.matricula" class="caption grey--text"> ({{ p.matricula }})</span></td>
                      <td>{{ formatFechaCorta(p.fecha_pago) }}</td>
                      <td>{{ format(p.monto_pagado) }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </template>
              <template v-else-if="mostrarComprobanteMismoAlumno(datosRevision)">
                <h3 class="subtitle-1 font-weight-bold mb-2">Usos del mismo alumno</h3>
                <v-alert type="info" dense outlined class="mb-3">
                  Este alumno ya utilizó este comprobante en otros ingresos.
                </v-alert>
                <v-simple-table dense class="mb-2">
                  <thead>
                    <tr>
                      <th>Folio</th>
                      <th>Fecha</th>
                      <th>Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="p in (datosRevision.folios_comprobante_mismo_alumno || [])" :key="'mismo-' + p.id_ingreso">
                      <td>{{ p.id_ingreso }}</td>
                      <td>{{ formatFechaCorta(p.fecha_pago) }}</td>
                      <td>{{ format(p.monto_pagado) }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </template>
              <template v-else>
              <h3 class="subtitle-1 font-weight-bold mb-2">Datos bancarios</h3>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>ID EXCEL</v-list-item-subtitle>
                  <v-list-item-title class="mt-2">{{ datosRevision.dbData ? datosRevision.dbData.idexcel_ingresos_detalles : '' }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>


              <!-- BANCO -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Banco</v-list-item-subtitle>
                  <v-list-item-title class="mt-2">
                    <v-chip
                      x-small
                      :color="getBancoColor( datosRevision.dbData ? datosRevision.dbData.bancoArchivo : '' )"
                      text-color="white"
                    >
                      {{ getBancoLabel( datosRevision.dbData ? datosRevision.dbData.bancoArchivo : '' ) }}

                    </v-chip>

                    <v-chip
                      x-small
                      :color="getBancoColor(datosRevision.dbData ? datosRevision.dbData.bancoArchivo : '' )"
                      text-color="white"
                    >
                      {{ datosRevision.dbData ? datosRevision.dbData.tipo_transaccion : '' }}
                    </v-chip>

                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Coincidencia</v-list-item-subtitle>
                  <v-list-item-title class="mt-2">
                    <v-chip x-small color="indigo" text-color="white">
                      {{ infoCoincidencia(datosRevision).coincidencia }}
                    </v-chip>
                  </v-list-item-title>
                  <v-list-item-title class="text-wrap caption mt-2" v-if="infoCoincidencia(datosRevision).valor_ingreso">
                    En el comprobante: {{ infoCoincidencia(datosRevision).valor_ingreso }}
                  </v-list-item-title>
                  <v-list-item-title class="text-wrap caption" v-if="infoCoincidencia(datosRevision).valor_banco">
                    En el banco: {{ infoCoincidencia(datosRevision).valor_banco }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>

              <!-- MONTO -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Monto</v-list-item-subtitle>
                  <v-list-item-title>
                    <div class="fondo_color">{{ montoBancoMostrar(datosRevision) }}</div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              
              <!-- FECHA Y HORA -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Fecha y Hora</v-list-item-subtitle>
                  <v-list-item-title class="mt-2">{{ getFechaMovimientoBanco(datosRevision.dbData) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>

              <!-- Concpeto -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Concepto/Referencia</v-list-item-subtitle>
                  <v-list-item-title class="text-wrap mt-2" v-if="datosRevision.dbData && datosRevision.dbData.tipo_transaccion == 'TPV' && datosRevision.dbData.bancoEncontrado == 'HSBC'">
                    <div class="fondo_color">{{ datosRevision.dbData.codigo_autorizacion }}</div>
                  </v-list-item-title>

                  <v-list-item-title class="text-wrap mt-2" v-if="datosRevision.dbData && datosRevision.dbData.tipo_transaccion == 'EDO CUENTA' && datosRevision.dbData.bancoEncontrado == 'SEVEN'">
                    {{ datosRevision.dbData.concepto }}
                  </v-list-item-title>

                  <v-list-item-title class="text-wrap mt-2" v-if="datosRevision.dbData && datosRevision.dbData.tipo_transaccion == 'EDO CUENTA' && datosRevision.dbData.bancoEncontrado == 'HSBC'">
                    {{ datosRevision.dbData.ref_hsbc_2 }}
                    {{ datosRevision.dbData.ref_hsbc_3 }}
                  </v-list-item-title>


                  <v-list-item-title class="text-wrap mt-2" v-if="datosRevision.dbData && datosRevision.dbData.tipo_transaccion == 'EDO CUENTA' && datosRevision.dbData.bancoEncontrado == 'BBVA'">
                    <div class="fondo_color">{{ datosRevision.dbData.folioMatch }}</div>
                    <br/>
                    {{ datosRevision.dbData.concepto }}

                  </v-list-item-title>

                  <v-list-item-title class="text-wrap mt-2" v-if="datosRevision.dbData && datosRevision.dbData.tipo_transaccion == 'ECOMMERCE'">
                    <div class="fondo_color">{{ datosRevision.dbData.bnrg_folio }}</div>
                  </v-list-item-title>

                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>

              <!-- DATOS PARA INDICAR QUE ESTA MAL EL MONTO -->
              <v-list-item v-if="datosRevision.error_monto && !datosRevision.match_hermanos">
                <v-list-item-content>
                  <v-list-item-subtitle class="font-weight-bold error--text">¡Diferencia en montos!</v-list-item-subtitle>
                  <v-list-item-title>
                    Excel: {{ datosRevision.dbData ? format( datosRevision.dbData.banco )  : ''}}
                    <v-icon small color="error">mdi-arrow-left-right</v-icon>
                    BD: {{ datosRevision.dbData ? format( datosRevision.monto_pagado )  : ''}}
                  </v-list-item-title>
                  <v-list-item-title class="error--text">
                    Diferencia: {{ datosRevision.dbData ? format( datosRevision.dbData.banco - datosRevision.monto_pagado ) : '' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="datosRevision.error_monto && !datosRevision.match_hermanos"></v-divider>
              </template>


              <div>
                <v-chip small color="blue"  dark v-if="datosRevision.aceptado == 1">Aceptado</v-chip>
                <v-chip small color="red"   dark v-else-if="datosRevision.aceptado == 2">Rechazado</v-chip>

                <span v-if="datosRevision.aceptado == 2"><br/>{{ datosRevision.motivo }}</span>

                <template v-if="puedeAceptarRechazarEnDialogo(datosRevision)">
                  <v-btn tile x-small color="green" dark v-if="!datosRevision.aceptado == 1 && ![18, 19, 17].includes(getdatosUsuarioERPERP.idpuesto)" class="mt-2" @click="aceptarComprobante( datosRevision )"><v-icon small>mdi-check</v-icon></v-btn>
                  <v-btn tile x-small color="red"   dark v-if="!datosRevision.aceptado == 1 && ![18, 19, 17].includes(getdatosUsuarioERPERP.idpuesto)" class="mt-2" @click="confirmarRechazo( datosRevision )"><v-icon small>mdi-close</v-icon></v-btn>
                </template>

              </div>
            </v-col>
          </v-row>
          <div class="d-flex justify-center py-3" v-if="totalPaginasModal > 1">
            <v-pagination
              v-model="paginaModal"
              :length="totalPaginasModal"
              :total-visible="7"
            ></v-pagination>
          </div>
        </v-card-text>
        <!-- Panel de búsqueda en base de datos -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogValidacion = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta              from '@/components/alertas/Alerta.vue';
  import carga               from '@/components/alertas/carga.vue';
  import PagosPorFecha       from '@/components/inscripciones/PagosPorFecha.vue'

  import validarErrores      from '@/mixins/validarErrores'
  import funcionesExcel      from '@/mixins/funcionesExcel'
  import { resaltarFechasEnTexto } from '@/utils/resaltarFechasTexto'
  import ImagenVisor         from '@/views/operaciones/rh/ImagenIncidencia.vue'

  import VueImageZoom from 'vue-image-zoom';
  import 'vue-image-zoom/dist/vue-image-zoom.css';

	const formatter = new Intl.NumberFormat('en-US', {
	  style: 'currency',
	  currency: 'USD',
	});

	// Componentes
  export default {
  	components:{
      Alerta,
      carga,
      VueImageZoom,
      PagosPorFecha,
      ImagenVisor,
    },

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
			// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,
      cargarMatch: false,

      search:'',

      opFiltroValidaPdf: 0,


      url_servidor: '',
      tablaMovimientos:[],
      tablaMovimientosModal:[],

      // Modales
      dialogPagos: false,
      reporteFechas: false,
      reporte: [],
      reporteFechas: {
        status: false
      },
      movimientosReporte: 0,
      revisadosReporte: 0,
      faltantesReporte: 0,
      porcentajeReporte: 0,
      headersReporte: [
        { text: "id_usuario_ultimo_cambio", value: "id_usuario_ultimo_cambio"},
        { text: "registro", value: "nombre_completo"},
	      { text: "movimientos", value: "movimientos"},
	      { text: "revisados", value: "revisados"},
	      { text: "faltantes", value: "faltantes"},
	      { text: "% revisados", value: "porcentaje"},
      ],

      dialogRevision: false,
      datosRevision: false,
      dialogValidacion: false,
      menuFechaInicio: false,
      menuFechaFinal: false,

      snack: false,
      snackColor: '',
      snackText: '',
      max25chars: v => v.length <= 25 || 'Input too long!',
      pagination: {},

      headersDos: [
	      { text: "id_ingreso"         , value: "id_ingreso"        },
	      { text: "Alumno"             , value: "alumno"            },
	      { text: "Monto pagado"       , value: "monto_pagado"      },
	      { text: "Fecha"              , value: "fecha_pago"        },
	      { text: "Forma pago"         , value: "forma_pago"        },
	      { text: "Registró"           , value: "nombre_completo"   },
	      { text: "Plantel"            , value: "plantel"           },
        { text: "Escuela"            , value: "tipo_escuela"      },
        { text: "Ciclo"              , value: "ciclo"             },
        { text: "Aut. Clave rastreo" , value: "aut_clave_rastreo" },
        { text: "Folio Oper."        , value: "folio_operacion"   },
	      { text: "Cuenta"             , value: "cuenta"            },
        { text: "Comprobante"        , value: "url_foto"          }, //Angel Rodriguez
	      { text: "Texto"              , value: "texto_completo"    }, //Angel Rodriguez
        { text: "Aceptado"           , value: "aceptado"          },
        { text: "Estatus"            , value: "estatus"           },
        { text: "Aut. Clave rastreo 2" , value: "aut_clave_rastreo_imagen" },
        { text: "Folio Oper. 2"        , value: "folio_operacion_imagen"   },
        { text: "Cuenta 2"             , value: "cuenta_imagen"            },

	    ],
			searchMovimientos: '',
			dialgImagen:false,
      imagen:null,

      headersTres: [
        { text: "id_ingreso"    , value: "id_ingreso"      },
        { text: "id_alumno"     , value: "id_alumno"       },
        { text: "Alumno"        , value: "alumno"          },
        { text: "Monto pagado"  , value: "monto_pagado"    },
        { text: "Viejo Plantel" , value: "viejoPlantel"    },
        { text: "Viejo Ciclo"   , value: "viejoCiclo"      },
        { text: "Nuevo Plantel" , value: "nuevoPlantel"    },
        { text: "Nuevo Ciclo"   , value: "nuevoCiclo"      },
      ],
      // tipos_pago:[
      //   { id: 1, tipo: 'EFECTIVO'},
      //   { id: 2, tipo: 'TARJETA'},
      //   { id: 3, tipo: 'DEPOSITO'},
      //   { id: 0, tipo: 'TODO' },
      // ],

      tipos_pago:[
        { id: 0, tipo: 'TODOS' },
        { id: 1, tipo: 'EFECTIVO'},
        { id: 2, tipo: 'DIGITAL'},
      ],

      encontrados:[
        { id: 1, tipo: 'TODOS'},
        { id: 2, tipo: 'ENCONTRADO'},
        { id: 3, tipo: 'NO ENCONTRADOS'},
      ],

      validados:[
        { id: 1, tipo: 'TODOS'},
        { id: 2, tipo: 'Con match'},
        { id: 3, tipo: 'Sin match'},
        { id: 4, tipo: 'Sin validar'},
        { id: 5, tipo: 'Match sin validar'},
      ],
      estatus: 1,

      encontrado: 1,

      formaPago: 0,
      formaPagoModal: 0,
      ciclos: [],
      ciclo: null,
      fecha_inicio:null,
      fecha_final:null,
      fecha_inicio_modal:null,
      fecha_final_modal:null,
      paginaModal: 1,
      porPaginaModal: 10,
      opEstatus: 4,
      opEstatusModal: 4,
      opEscuelaModal: 3,
      datosPago: null,
      dialogConfirma: false,
      conceptosError:[],
      opEscuela: 3,
      texto_completo: '',

      dialgImagen: false,
      imagen: '',
      zoomActivo: false,
      origenZoom: 'center center',

      dialgImagenCorte: false,
      imagenCorte: '',
      imagenesVisorCorte: [],
      indiceImagenVisorCorte: 0,

    }),

    computed: {
      ...mapGetters("login", ["getdatosUsuarioERPERP"]),

      baseUrlComprobante() {
        const base = String((this.$http && this.$http.defaults && this.$http.defaults.baseURL) || '')
          .replace(/\/?$/, '/')
        if (base && base !== '/') return base + 'comprobante-pago'
        return String(this.url_servidor || '').replace(/\/?$/, '/') + 'comprobante-pago'
      },

      movimientosCorte(){
        return Array.isArray( this.tablaMovimientos ) ? this.tablaMovimientos : []
      },

      filterCorte(){

        let data = this.movimientosCorte

        if( this.opEstatus == 1 ){
          data = data.filter( el => { return el.aceptado == 1 })
        }

        if( this.opEstatus == 2 ){
          data = data.filter( el => { return el.aceptado == 2 })
        }

        if( this.opEstatus == 3 ){
          data = data.filter( el => { return !el.aceptado })
        }


        // Filtro por forma de pago
        if( this.formaPago == 2){
          data = data.filter( el => { return [2, 3, 4].includes( el.id_forma_pago ) })
        }

        // Filtro por forma de pago
        // if( this.formaPago == 3){
          // data = data.filter( el => { return [2].includes( el.id_forma_pago ) })
        // }

        // Filtro por forma de pago
        if( this.formaPago == 1){
          data = data.filter( el => { return [1].includes( el.id_forma_pago ) })
        }

        if( this.opEscuela == 1 ){
          data = data.filter( el => { return Number(el.escuela) == 1 })
        }

        if( this.opEscuela == 2 ){
          data = data.filter( el => { return Number(el.escuela) == 2 })
        }

        if( this.encontrado == 2 ){
          data = data.filter( el => { return el.encontrado == 1 })
        }

        if( this.encontrado == 3 ){
          data = data.filter( el => { return el.encontrado == 0 })
        }

        return data
      },

      filterMontos(){

        let data = this.movimientosCorte

        // Filtro por forma de pago
        if( this.formaPago == 2){
          data = data.filter( el => { return [2, 3, 4].includes( el.id_forma_pago ) })
        }

        // Filtro por forma de pago
        // if( this.formaPago == 3){
          // data = data.filter( el => { return [2].includes( el.id_forma_pago ) })
        // }

        // Filtro por forma de pago
        if( this.formaPago == 1){
          data = data.filter( el => { return [1].includes( el.id_forma_pago ) })
        }

        if( this.opEscuela == 1 ){
          data = data.filter( el => { return Number(el.escuela) == 1 })
        }

        if( this.opEscuela == 2 ){
          data = data.filter( el => { return Number(el.escuela) == 2 })
        }

        if( this.encontrado == 2 ){
          data = data.filter( el => { return el.encontrado == 1 })
        }

        if( this.encontrado == 3 ){
          data = data.filter( el => { return el.encontrado == 0 })
        }

        return data
      },

      movimientosModal(){
        return Array.isArray( this.tablaMovimientosModal ) ? this.tablaMovimientosModal : []
      },

      baseValidados(){
        let data = this.movimientosModal

        if( this.opEscuelaModal == 1 ){
          data = data.filter( el => { return Number(el.escuela) == 1 })
        }

        if( this.opEscuelaModal == 2 ){
          data = data.filter( el => { return Number(el.escuela) == 2 })
        }

        if( this.formaPagoModal == 1 ){
          data = data.filter( el => { return [1].includes( el.id_forma_pago ) })
        }

        if( this.formaPagoModal == 2 ){
          data = data.filter( el => { return [2, 3, 4].includes( el.id_forma_pago ) })
        }

        return data
      },

      filterValidados(){
        let data = this.baseValidados

        if( this.opEstatusModal == 1 ){
          data = data.filter( el => Number(el.aceptado) == 1 )
        }

        if( this.opEstatusModal == 2 ){
          data = data.filter( el => Number(el.aceptado) == 2 )
        }

        if( this.opEstatusModal == 3 ){
          data = data.filter( el => this.esPendienteValidar(el) )
        }

        if( this.opFiltroValidaPdf == 1){
          return data.filter( el => el.estatus == 2 && !el.error_monto )
        }

        if( this.opFiltroValidaPdf == 2){
          return data.filter( el => !el.estatus )
        }

        if( this.opFiltroValidaPdf == 3){
          return data.filter( el => this.esPendienteValidar(el) )
        }

        if( this.opFiltroValidaPdf == 4){
          return data.filter( el => el.estatus == 2 && this.esPendienteValidar(el) )
        }

        if( this.opFiltroValidaPdf == 5){
          return data.filter( el => el.estatus == 2 && el.error_monto )
        }

        return data
      },

      filterValidadosFiltrados(){
        const q = String(this.search || '').trim().toLowerCase()
        if( !q ) return this.filterValidados

        return this.filterValidados.filter(el => {
          return [
            el.alumno,
            el.id_ingreso,
            el.plantel,
            el.folio_operacion,
            el.aut_clave_rastreo,
            el.forma_pago,
            el.ciclo,
          ].some(v => String(v || '').toLowerCase().includes(q))
        })
      },

      totalPaginasModal(){
        return Math.max(1, Math.ceil(this.filterValidadosFiltrados.length / this.porPaginaModal))
      },

      filterValidadosPagina(){
        const inicio = (this.paginaModal - 1) * this.porPaginaModal
        return this.filterValidadosFiltrados.slice(inicio, inicio + this.porPaginaModal)
      },

      rangoPaginaModal(){
        if( !this.filterValidadosFiltrados.length ) return '0-0'
        const inicio = (this.paginaModal - 1) * this.porPaginaModal + 1
        const fin = Math.min(this.paginaModal * this.porPaginaModal, this.filterValidadosFiltrados.length)
        return `${inicio}-${fin}`
      },

      filterMovimientos( ){ 

        return this.filterMontos.length

      },

      filterRvisados( ){ 

        return this.filterMontos.filter( el => { return el.aceptado }).length

      },

      filterFaltantes( ){ 

        return this.filterMontos.filter( el => { return !el.aceptado }).length

      },

      filterRechazados( ){ 

        return this.filterMontos.filter( el => { return el.aceptado == 2 }).length

      },

      filterMovimientosMonto( ){ 

        return this.format( this.filterMontos.map(item => item.monto_pagado  ).reduce((prev, curr) => prev + curr, 0))

      },

      filterRevisadosMonto( ){ 

        return this.format( this.filterMontos.filter( el => { return el.aceptado }).map(item => item.monto_pagado  ).reduce((prev, curr) => prev + curr, 0))

      },

      filterFaltantesMonto( ){ 

        return this.format( this.filterMontos.filter( el => { return !el.aceptado }).map(item => item.monto_pagado  ).reduce((prev, curr) => prev + curr, 0))

      },

      filterRechazadosMonto( ){ 

        return this.format( this.filterMontos.filter( el => { return el.aceptado == 2 }).map(item => item.monto_pagado  ).reduce((prev, curr) => prev + curr, 0))

      },

      totalRegistros( ){

        return this.filterValidadosFiltrados.length

      },

      registrosValidados( ){

        return this.baseValidados.filter( el => el.aceptado == 1 ).length

      },

      avanceValidados( ){

        if( !this.baseValidados.length ){
          return 0
        }

        let validados = this.baseValidados.filter( el => el.aceptado == 1 ).length

        if( !validados ){
          return 0
        }

        return (( validados / this.baseValidados.length ) * 100 ).toFixed( 2 )

      },

      registrosConMatch( ){

        return this.baseValidados.filter( el => el.estatus == 2 && !el.error_monto ).length

      },

      registrosSinMatch( ){

        return this.baseValidados.filter( el => !el.estatus ).length

      },

      registrosErrorMonto( ){

        return this.baseValidados.filter( el => el.estatus == 2 && el.error_monto ).length

      },

      minFechaFinal(){
        return this.fecha_inicio_modal || null
      },

      maxFechaFinal(){
        if( !this.fecha_inicio_modal ) return null
        const d = new Date(`${this.fecha_inicio_modal}T00:00:00`)
        d.setDate(d.getDate() + 14)
        const y = d.getFullYear()
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${y}-${m}-${day}`
      },

    },

    async created( ) {

    	this.url_servidor = "https://escuelakpi.club/kpi/"

      await this.getCiclos()
      await this.getConceptorError()

    },

    watch: {
      opFiltroValidaPdf(){ this.paginaModal = 1 },
      formaPagoModal(){ this.paginaModal = 1 },
      opEstatusModal(){ this.paginaModal = 1 },
      opEscuelaModal(){ this.paginaModal = 1 },
      search(){ this.paginaModal = 1 },
      filterValidadosFiltrados(){
        if( this.paginaModal > this.totalPaginasModal ){
          this.paginaModal = 1
        }
      },
    },

    methods: {

      normalizarMovimientos( data ){
        if( Array.isArray( data ) ){
          return data
        }

        this.validarErrorDirecto( data && data.message ? data.message : 'No se recibieron movimientos para mostrar' )
        return []
      },

      toggleZoom(e) {
        const cont = this.$refs.contenedorZoom
        const img = this.$refs.imagenZoom
        if (!cont || !img) return

        if (!this.zoomActivo) {
          const rect = img.getBoundingClientRect()
          const offsetX = (e.clientX - rect.left) / rect.width
          const offsetY = (e.clientY - rect.top) / rect.height
          this.zoomActivo = true
          this.$nextTick(() => {
            cont.scrollLeft = img.width * offsetX - cont.clientWidth / 2
            cont.scrollTop = img.height * offsetY - cont.clientHeight / 2
          })
        } else {
          this.zoomActivo = false
          this.$nextTick(() => {
            cont.scrollLeft = 0
            cont.scrollTop = 0
          })
        }
      },

      cerrarDialogo() {
        this.dialgImagen = false
        this.zoomActivo = false
        this.origenZoom = 'center center'
        this.imagen = ''
      },

      cerrarVisorCorte() {
        this.dialgImagenCorte = false
        this.imagenCorte = ''
        this.imagenesVisorCorte = []
        this.indiceImagenVisorCorte = 0
      },

      getReporteTotalPagos() {
        const hoy = new Date()
        const hasta = hoy.toISOString().split('T')[0]
        const desdeDate = new Date(hoy)
        desdeDate.setDate(desdeDate.getDate() - 14)
        const desde = desdeDate.toISOString().split('T')[0]
        this.consultar(desde, hasta, 1)
      },
      comprobarImagen(value) {            //Angel Rodriguez
        this.imagen = value && value.url_foto
        this.texto_completo = value && value.texto_completo
        this.datosPago = value
        this.zoomActivo = false
        this.dialgImagen = true
      },

      /** Evidencias de corte: visor tipo tickets (slider + zoom). */
      verEvidenciaCorte(nombre, indice = 0) {
        if (!nombre) return
        const lista = this.evidenciasCorte(this.datosRevision)
        const nombres = (lista.length ? lista : [nombre])
          .map((e) => String(e || '').trim())
          .filter(Boolean)
        if (!nombres.length) return
        const idx = Math.max(0, Math.min(Number(indice) || 0, nombres.length - 1))
        this.imagenCorte = nombres[idx]
        this.imagenesVisorCorte = nombres.map((foto) => ({ foto }))
        this.indiceImagenVisorCorte = idx
        this.dialgImagenCorte = true
      },

      getCiclos() {
        this.cargar = true;
        this.ciclos = [];
        return this.$http.get("ciclos.activos.erp").then((response) => {
          this.ciclos = response.data;
          this.cargar = false;
        }).catch((error) => {
          this.validarError(error);
        }).finally(() => {
          this.cargar = false;
        });
      },

      getConceptorError() {
        this.cargar = true;
        this.conceptosError = [];
        return this.$http.get("concepto.errores").then((response) => {
          this.conceptosError = response.data;
          this.cargar = false;
        }).catch((error) => {
          this.validarError(error);
        }).finally(() => {
          this.cargar = false;
        });
      },

      esPendienteValidar(el){
        const n = Number(el && el.aceptado)
        return n !== 1 && n !== 2
      },

      rangoModalValido(forzar){
        if( !this.fecha_inicio_modal ){
          return forzar ? this.validarErrorDirecto('Selecciona una fecha de inicio') : false
        }

        if( !this.fecha_final_modal ){
          return forzar ? this.validarErrorDirecto('Selecciona una fecha final') : false
        }

        if( this.fecha_final_modal < this.fecha_inicio_modal ){
          this.validarErrorDirecto('La fecha final no puede ser menor a la fecha de inicio')
          return false
        }

        const ini = new Date(`${this.fecha_inicio_modal}T00:00:00`)
        const fin = new Date(`${this.fecha_final_modal}T00:00:00`)
        const dias = Math.round((fin - ini) / 86400000)
        if( dias > 14 ){
          this.validarErrorDirecto('Elige un rango de máximo 15 días')
          return false
        }

        return true
      },

      limpiarFechaModal(cual){
        if( cual === 'inicio' ){
          this.fecha_inicio_modal = null
          this.fecha_final_modal = null
        } else {
          this.fecha_final_modal = null
        }
        this.tablaMovimientosModal = []
      },

      seleccionarFechaModal(cual, fecha){
        if( !fecha ) return
        if( cual === 'inicio' ){
          this.fecha_inicio_modal = fecha
          this.menuFechaInicio = false
          if( this.fecha_final_modal && this.fecha_final_modal < fecha ){
            this.fecha_final_modal = null
            this.tablaMovimientosModal = []
          }
          const maxFin = this.maxFechaFinal
          if( this.fecha_final_modal && maxFin && this.fecha_final_modal > maxFin ){
            this.fecha_final_modal = null
            this.tablaMovimientosModal = []
          }
        } else {
          this.fecha_final_modal = fecha
          this.menuFechaFinal = false
        }
        if( this.fecha_inicio_modal && this.fecha_final_modal ){
          this.consultarValidacion()
        }
      },

      abrirValidacion(){
        this.tablaMovimientosModal = []
        this.fecha_inicio_modal = null
        this.fecha_final_modal = null
        this.opEstatusModal = 4
        this.paginaModal = 1
        this.search = ''
        this.dialogValidacion = true
      },

      consultarValidacion(forzar){
        if( !this.rangoModalValido(forzar) ){
          return false
        }

        this.consultar( null, null, 2 )
      },

      consultar(fechaInicio, fechaFinal, tipo){

        if( tipo == 2 && !this.rangoModalValido(true) ){
          return false
        }

        if( tipo == 2 ){
          this.cargarMatch = true
        } else {
          this.cargar = true
        }

        const payload = {
          id_ciclo: tipo == 2 ? null : this.ciclo,
          fecha_inicio: tipo == 2 ? this.fecha_inicio_modal : (fechaInicio ? fechaInicio : this.fecha_inicio),
          fecha_final: tipo == 2 ? this.fecha_final_modal : (fechaFinal ? fechaFinal : this.fecha_final),
          tipo,
          ...( tipo == 2 ? { incluir_aceptados: true } : {} ),
        }

        return this.$http.post("movimientos.corte", payload )
        .then((response) => {
          const movimientos = this.normalizarMovimientos( response.data )

          // Si hay fechas en los argumentos del metodo entonces es para un modal
          if(fechaInicio && fechaFinal) {
            movimientos.map(d => {
              // Buscar si ya existe un registro con el mismo id_usuario_ultimo_cambio
              const existente = this.reporte.find(r => r.id_usuario_ultimo_cambio === d.id_usuario_ultimo_cambio);
              if (existente) {
                // Si ya existe, actualizamos los valores según sea necesario
                existente.movimientos += 1 || 0;
                if( d.aceptado ) existente.revisados += 1 || 0;
                if( !d.aceptado) existente.faltantes += 1 || 0;
                // Calcular porcentaje al final
              } else {
                // Si no existe, lo agregamos con valores iniciales
                this.reporte.push({
                  id_usuario_ultimo_cambio: d.id_usuario_ultimo_cambio,
                  nombre_completo: d.nombre_completo,
                  movimientos: 1,
                  revisados: d.aceptado ? 1 : 0,
                  faltantes: !d.aceptado ? 1 : 0,
                  porcentaje: 0
                });
              }
            })

            this.movimientosReporte = movimientos.length;
            this.revisadosReporte = movimientos.filter( el => { return el.aceptado }).length;
            this.faltantesReporte = movimientos.filter( el => { return !el.aceptado }).length;
            const porcentaje = movimientos.length ? ( movimientos.filter( el => { return el.aceptado }).length / movimientos.length ) * 100 : 0;
            this.porcentajeReporte = porcentaje.toFixed(1);

            // Porcentajes de reporte
            this.reporte.map(d => {
              d.porcentaje = ( ( d.revisados / d.movimientos ) * 100 ).toFixed(1);
            })

          }
          else if( tipo == 2 ){
            this.tablaMovimientosModal = movimientos;
            this.tablaMovimientos = movimientos;
          }
          else {
            this.tablaMovimientos = movimientos;
          }

        }).catch((error) => {

          this.validarError(error);

        }).finally(() => {
          if(fechaInicio && fechaFinal) this.dialogPagos = true
          this.cargar = false;
          this.cargarMatch = false;

        });
      },

      aceptarComprobante( data ){
        this.cargar = true;

        // Solo marcar aceptado; fecha_pago permanece como alta en sistema (no fecha del banco).
        const payload = {
          id_ingreso: data.id_ingreso,
          aceptado: 1,
        }

        data.aceptado = 1

        return this.$http.post("ingreso.aceptado", payload ).then((response) => {

          this.validarSuccess(response.data.message)
          this.cargar = false;

        }).catch((error) => {

          this.validarError(error);

        }).finally(() => {

          this.cargar = false;

        });
      },

      confirmarRechazo( data ){
        this.datosPago = data
        this.dialogConfirma = true
      },

      rechazarComprobante( data ){
        this.cargar = true;

        if( !data.iderrores_pagos ){
          return this.validarErrorDirecto('Selecciona un motivo')
        }

        const payload = {
          id_ingreso: data.id_ingreso,
          aceptado: 2,
          iderrores_pagos: data.iderrores_pagos,
        }

        data.aceptado = 2

        return this.$http.post("ingreso.rechazado", payload ).then((response) => {

          this.validarSuccess(response.data.message)
          this.dialogConfirma = false
          this.cargar = false;

        }).catch((error) => {

          this.validarError(error);

        }).finally(() => {

          this.cargar = false;

        });
      },

      save ( data ) {
        this.cargar = true;

        const payload = {
          id_ingreso: data.id_ingreso,
          aut_clave_rastreo: data.aut_clave_rastreo,
        }

        return this.$http.post("ingreso.clave.rastreo", payload ).then((response) => {

          this.validarSuccess(response.data.message)
          this.cargar = false;

        }).catch((error) => {

          this.validarError(error);

        }).finally(() => {

          this.cargar = false;

        });
      },

      montoBancoMostrar(el) {
        if (!el || !el.dbData || el.dbData.banco == null || el.dbData.banco === '') return ''
        if (el.estatus != 2) return ''
        if (el.error_monto && !el.match_hermanos) return ''
        return this.format(el.dbData.banco)
      },

      encontradoExport(el) {
        if (!el || !el.match_hermanos) return 0
        const grupo = Array.isArray(el.hermanos_grupo) ? el.hermanos_grupo : []
        const n = grupo.filter(h => h && h.id_ingreso != null).length
        return n > 0 ? n : 1
      },

      /** Comprobante reutilizado por otro alumno (histórico); Match Hermanos conserva datos bancarios. */
      mostrarFoliosComprobanteReutilizado(el) {
        if (!el || el.match_hermanos) return false
        if (this.mostrarValidadoPorCorte(el)) return false
        if (!el.comprobante_reutilizado) return false
        return Array.isArray(el.folios_comprobante_previos) && el.folios_comprobante_previos.length > 0
      },

      /** Mismo alumno reutilizó el comprobante (2.º+ uso). */
      mostrarComprobanteMismoAlumno(el) {
        if (!el || el.match_hermanos) return false
        if (this.mostrarValidadoPorCorte(el)) return false
        // Si también hay reuso por otro alumno, gana ese caso (chips / diálogo / botones)
        if (this.mostrarFoliosComprobanteReutilizado(el)) return false
        if (!el.comprobante_reutilizado_mismo_alumno) return false
        return Array.isArray(el.folios_comprobante_mismo_alumno)
          && el.folios_comprobante_mismo_alumno.length > 0
      },

      /**
       * ✓/✗ en diálogo: bloqueados si validado por corte o reuso otro alumno.
       * Habilitados en caso solo mismo alumno (o sin alerta de comprobante).
       */
      puedeAceptarRechazarEnDialogo(el) {
        if (!el) return false
        if (this.mostrarValidadoPorCorte(el)) return false
        if (this.mostrarFoliosComprobanteReutilizado(el)) return false
        return true
      },

      /** Efectivo validado por folio Corte-YYYYMMDD-N (prioridad sobre banco / reuso). */
      mostrarValidadoPorCorte(el) {
        if (!el) return false
        if (el.validado_por_corte) return true
        const folio = String(el.folio_operacion || '').trim()
        return /^Corte-\d{8}-\d+$/i.test(folio)
      },

      evidenciasCorte(el) {
        const lista = el && el.corte_info && el.corte_info.evidencias
        if (!Array.isArray(lista)) return []
        return lista.map((e) => String(e || '').trim()).filter(Boolean)
      },

      urlComprobantePago(nombre) {
        if (!nombre) return ''
        const base = String((this.$http && this.$http.defaults && this.$http.defaults.baseURL) || '')
          .replace(/\/?$/, '/')
        if (base && base !== '/') {
          return base + 'comprobante-pago/' + nombre
        }
        const fallback = String(this.url_servidor || '').replace(/\/?$/, '/')
        return fallback + 'comprobante-pago/' + nombre
      },

      formatFechaCorta(fecha) {
        if (!fecha) return ''
        const s = String(fecha)
        if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10)
        try {
          const d = new Date(fecha)
          if (Number.isNaN(d.getTime())) return s
          return d.toISOString().slice(0, 10)
        } catch (e) {
          return s
        }
      },

      infoCoincidencia(el) {
        const d = el && el.dbData
        if (d && d.coincidencia) {
          return {
            coincidencia: d.coincidencia,
            valor_ingreso: d.valor_ingreso || '',
            valor_banco: d.valor_banco || '',
          }
        }
        if (el && el.estatus == 2) {
          return { coincidencia: 'Coincidencia', valor_ingreso: '', valor_banco: '' }
        }
        return { coincidencia: 'Sin coincidencia', valor_ingreso: '', valor_banco: '' }
      },

      foliosHermanos(el) {
        if (!el || !el.match_hermanos) return ''
        const grupo = Array.isArray(el.hermanos_grupo) ? el.hermanos_grupo : []
        const ids = grupo
          .map(h => h && h.id_ingreso)
          .filter(id => id != null)
        return ids.length ? ids.join(', ') : ''
      },

      mapaFilaExport(el) {
        const banco = el.dbData || {}
        const coin = this.infoCoincidencia(el)
        return {
          'ID Ingreso': el.id_ingreso,
          'Encontrado': this.encontradoExport(el),
          'Folios': this.foliosHermanos(el),
          'Coincidencia': coin.coincidencia,
          'En el comprobante': coin.valor_ingreso,
          'En el banco': coin.valor_banco,
          'Alumno': el.alumno,
          'Monto pagado': el.monto_pagado,
          'Fecha pago': this.getFechaPagoComprobante(el),
          'Forma pago': el.forma_pago,
          'Plantel': el.plantel,
          'Escuela': this.getEscuelaLabel(el),
          'Ciclo': el.ciclo,
          'Clave rastreo': el.aut_clave_rastreo,
          'Folio operación': el.folio_operacion,
          'Match': this.etiquetaMatch(el),
          'Validación': this.etiquetaValidacion(el),
          'Motivo': el.motivo || '',
          'ID Excel': banco.idexcel_ingresos_detalles || '',
          'Banco': this.getBancoLabel(banco.bancoArchivo),
          'Tipo transacción': banco.tipo_transaccion || '',
          'Monto banco': this.montoBancoMostrar(el) ? (banco.banco || '') : '',
          'Fecha banco': this.getFechaMovimientoBanco(banco),
          'Concepto/Referencia': this.conceptoBanco(el),
          'Error monto': el.error_monto ? 'Sí' : 'No',
          'Diferencia': el.error_monto && banco.banco != null ? (banco.banco - el.monto_pagado) : '',
        }
      },

      exportar( ){
        if (!this.filterCorte.length) {
          this.validarErrorDirecto('No hay resultados para exportar')
          return
        }
        // TEMP prueba: descarga local (revertir a exportExcel)
        this.exportarExcelDirecto(this.filterCorte, 'PAGOS')
      },

      etiquetaMatch(el) {
        if (this.mostrarValidadoPorCorte(el)) return 'Validado por corte'
        if (el.estatus == 2 && el.match_hermanos && !el.error_monto) return 'Match Hermanos'
        if (el.estatus == 2 && el.error_monto) return 'Match Error monto'
        if (el.estatus == 2 && !el.error_monto) return 'Con Match 100%'
        return 'Sin Match'
      },

      etiquetaValidacion(el) {
        if (el.aceptado == 1) return 'Aceptado'
        if (el.aceptado == 2) return 'Rechazado'
        return 'Pendiente'
      },

      conceptoBanco(el) {
        const banco = el.dbData
        if (!banco) return ''
        if (banco.tipo_transaccion == 'TPV' && banco.bancoEncontrado == 'HSBC') return banco.codigo_autorizacion || ''
        if (banco.tipo_transaccion == 'EDO CUENTA' && banco.bancoEncontrado == 'SEVEN') return banco.concepto || ''
        if (banco.tipo_transaccion == 'EDO CUENTA' && banco.bancoEncontrado == 'HSBC') {
          return [banco.ref_hsbc_2, banco.ref_hsbc_3].filter(Boolean).join(' ')
        }
        if (banco.tipo_transaccion == 'EDO CUENTA' && banco.bancoEncontrado == 'BBVA') {
          return [banco.folioMatch, banco.concepto].filter(Boolean).join(' ')
        }
        if (banco.tipo_transaccion == 'ECOMMERCE') return banco.bnrg_folio || ''
        return banco.concepto || banco.folioMatch || ''
      },

      exportarMatch() {
        if (!this.fecha_inicio_modal || !this.fecha_final_modal) {
          this.validarErrorDirecto('Selecciona un rango de fechas para exportar')
          return
        }

        if (!this.filterValidados.length) {
          this.validarErrorDirecto('No hay resultados para exportar')
          return
        }

        const dataExport = this.filterValidados.map(el => this.mapaFilaExport(el))

        // TEMP prueba: descarga local (revertir a exportExcel)
        this.exportarExcelDirecto(dataExport, 'MATCH-PAGOS')
      },

      saveFolio( data ) {
        this.cargar = true;

        const payload = {
          id_ingreso       : data.id_ingreso,
          folio_operacion: data.folio_operacion,
        }

        return this.$http.post("ingreso.folio.operacion", payload ).then((response) => {

          this.validarSuccess(response.data.message)
          this.cargar = false;

        }).catch((error) => {

          this.validarError(error);

        }).finally(() => {

          this.cargar = false;

        });
      },

      saveCuenta( data ) {
        this.cargar = true;

        const payload = {
          id_ingreso       : data.id_ingreso,
          cuenta: data.cuenta,
        }

        return this.$http.post("ingreso.cuenta", payload ).then((response) => {

          this.validarSuccess(response.data.message)
          this.cargar = false;

        }).catch((error) => {

          this.validarError(error);

        }).finally(() => {

          this.cargar = false;

        });
      },

      cancel () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      open () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      close () {
        console.log('Dialog closed')
      },


      format( value ){
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format( value );
      },

      getEscuelaLabel(data) {
        if (!data) return 'SIN ESCUELA'
        if (data.tipo_escuela) return data.tipo_escuela
        return Number(data.escuela) == 2 ? 'FAST' : 'INBI'
      },

      getEscuelaColor(data) {
        return this.getEscuelaLabel(data) == 'FAST' ? 'blue darken-3' : 'green darken-2'
      },

      getFechaMovimientoBanco(data) {
        if (!data) return ''
        return data.fecha || data.fecha_registro || data.bnrg_fecha_trans || data.bnrg_fecha || data.fecha_transaccion || ''
      },

      getFechaPagoComprobante(data) {
        if (!data) return ''
        return data.fecha_pago_comprobante || this.getFechaMovimientoBanco(data.dbData) || data.fecha_pago || ''
      },

      textoCompletoConFechaResaltada(texto) {
        return resaltarFechasEnTexto(texto)
      },

      getBancoColor(banco) {
        if (!banco) return 'grey';

        const bancoUpper = banco.toString().toUpperCase();
        if (bancoUpper.includes('BBVA') || bancoUpper.includes('BANCOMER')) return 'blue darken-1';
        if (bancoUpper.includes('BR') || bancoUpper.includes('BANREGIO')) return 'purple';
        if (bancoUpper.includes('SANTANDER')) return 'red darken-1';
        if (bancoUpper.includes('BANAMEX') || bancoUpper.includes('CITI')) return 'blue-grey';
        if (bancoUpper.includes('BANORTE')) return 'orange darken-1';
        if (bancoUpper.includes('HSBC')) return 'red';

        return 'green'; // Para otros bancos
      },


      getTipoArchivo(tipo) {
        if (!tipo) return 'grey';

        const bancoUpper = tipo.toString().toUpperCase();
        if (bancoUpper.includes('EDO CUENTA') || bancoUpper.includes('BANCOMER')) return 'green';
        if (bancoUpper.includes('TPV') || bancoUpper.includes('BANREGIO')) return 'purple';
        if (bancoUpper.includes('COMERCIO ELECTRONICO')) return 'yellow';

        return 'green'; // Para otros bancos
      },

      getBancoLabel(banco) {
        if (!banco) return 'N/A';

        const bancoUpper = banco.toString().toUpperCase();
        if (bancoUpper.includes('BBVA') || bancoUpper.includes('BANCOMER')) return 'BBVA';
        if (bancoUpper.includes('BR') || bancoUpper.includes('BANREGIO')) return 'BanRegio';
        if (bancoUpper.includes('SANTANDER')) return 'Santander';
        if (bancoUpper.includes('BANAMEX') || bancoUpper.includes('CITI')) return 'Banamex';
        if (bancoUpper.includes('BANORTE')) return 'Banorte';
        if (bancoUpper.includes('HSBC')) return 'HSBC';

        return banco; // Para otros bancos, mostrar el valor original
      },
    }
  };
</script>

<style scope>

.zoomable-img {
  max-width: 100%;
  max-height: 100%;
  cursor: zoom-in;
  transition: transform 0.3s ease;
}

.fondo_color {
  background-color: yellow;
}

.texto-completo-fechas >>> .fecha-resaltada {
  background-color: #ffeb3b;
  color: #000;
  padding: 0 3px;
  border-radius: 2px;
  font-weight: 800;
  font-size: calc(1em + 6px);
}

</style>
